module.exports = __webpack_public_path__ + "static/media/facebook-social-media-svgrepo-com.f92f8c83.svg";